import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="tech-grid bg-blue-950 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22etxqj6b0mv2">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yejliorx507r">
        <div className="text-center" data-id="element-22" data-mp="1ao7ah51dmncy">
          <span className="silver-metal inline-flex items-center gap-2 rounded-md px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-blue-950" data-id="element-23" data-mp="1ap8mbbq7vdvq">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jgiti5u5v8iw" /> Incluidos sin costo extra
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-25" data-mp="1episophx86b4">
            Los {totalBonuses} Bonos Estratégicos
          </h2>
        </div>

        <div className="mt-10 grid gap-5" data-id="element-26" data-mp="myuunmbjnh1o">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-6 rounded-xl border border-slate-300/25 bg-blue-900 p-6 sm:p-8 md:grid-cols-[220px_1fr]" data-id="element-27" data-mp="29rbhexohv9z5" data-mpi={index}>
                <div className="flex items-start justify-between gap-4 md:flex-col md:justify-start" data-id="element-28" data-mp="1vsbv3wogf765">
                  <div className="flex items-center gap-3 md:flex-col md:items-start" data-id="element-29" data-mp="20roeg7g49w3z">
                    <span className="silver-metal flex h-12 w-12 items-center justify-center rounded-md text-blue-950" data-id="element-30" data-mp="20trb3abrynho">
                      <Icon className="h-6 w-6" aria-hidden="true" data-id="element-31" data-mp="3c73an90i4jy1" />
                    </span>
                    <p className="text-xs font-extrabold uppercase tracking-[.16em] text-slate-300" data-id="element-32" data-mp="3h5el9lymeyhb">Bono {bonus.number}</p>
                  </div>
                  <p className="text-right text-xs font-bold text-slate-300 md:text-left" data-id="element-33" data-mp="1h1u7hyi8po79">
                    <span className="block line-through" data-id="element-34" data-mp="1c3iwhkg7l7ng">Valor real: {bonus.value}</span>
                    <span className="silver-metal mt-2 inline-block rounded-md px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wide text-blue-950" data-id="element-35" data-mp="1q3248c53ygz8">
                      Gratis
                    </span>
                  </p>
                </div>

                <div className="flex flex-col" data-id="element-36" data-mp="tdt4t67qt1zr">
                  <h3 className="text-xl font-extrabold leading-tight text-white" data-id="element-37" data-mp="tf44atu5nnl2">{bonus.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-200" data-id="element-38" data-mp="1760w4ig9c0r2">{bonus.description}</p>

                  {bonus.items && <ul className="mt-4 grid gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-39" data-mp="12co8aajejxzd">
                      {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-slate-100" data-id="element-40" data-mp="anux4r7uxawn">
                          <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-slate-300" aria-hidden="true" data-id="element-41" data-mp="iv1amoaffhg" />
                          {item}
                        </li>)}
                    </ul>}

                  {bonus.note && <p className="mt-4 text-sm italic leading-relaxed text-slate-300" data-id="element-42" data-mp="3moi4bd6niz52">{bonus.note}</p>}

                  {bonus.benefit && <p className="mt-5 rounded-lg border-l-4 border-slate-300 bg-blue-950 px-4 py-3 text-sm font-semibold text-white" data-id="element-43" data-mp="j9cq4g601qxj">
                      {bonus.benefit}
                    </p>}
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl border-2 border-slate-300 bg-blue-900 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-44" data-mp="ea039vf4ojuy">
          <div data-id="element-45" data-mp="2z0s5w7huxrzc">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-slate-300" data-id="element-46" data-mp="2z1jtav1awjej">
              Valor total de los {totalBonuses} bonos
            </p>
            <p className="mt-1 text-2xl font-extrabold tracking-tight text-white line-through decoration-red-500 decoration-2" data-id="element-47" data-mp="3f9zp0qnfiju6">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-48" data-mp="35g94fwufatjr">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-slate-300" data-id="element-49" data-mp="30jscerk3rv1e">Tu precio hoy</p>
            <p className="mt-1 inline-flex items-center gap-2 text-3xl font-extrabold tracking-tight text-slate-100" data-id="element-50" data-mp="21wikvrzg8au">
              <GiftIcon className="h-7 w-7 text-slate-300" aria-hidden="true" data-id="element-51" data-mp="3t991bf8iktsv" /> <span className="silver-text" data-id="element-52" data-mp="3o8blvaew2dv2">GRATIS</span>
            </p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-slate-300" data-id="element-53" data-mp="3ja9u813ed67z">
          Solo incluidos en esta oferta.
        </p>
      </div>
    </section>;
}